import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import axios from 'axios';
import * as XLSX from 'xlsx';
@Component({
  selector: 'app-canpergroup',
  templateUrl: './canpergroup.component.html',
  styleUrls: ['./canpergroup.component.css']
})
export class CanpergroupComponent implements OnInit {
  @ViewChild('table') table: ElementRef;
  Pergroup: UntypedFormGroup;

  constructor(private spinner: NgxSpinnerService, private router: Router) {

  }

  ngOnInit(): void {
    //this.LoadZone();
  }
  date = { date1: new Date('2025-12-1'), date2: new Date('2026-04-30') }
  dateS = { date1: new Date('2025-12-1'), date2: new Date(Date.now()) }


  ExportExcel() {
    let options: any = {
      year: "numeric", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit"
    };
    var currentDate = new Date();
    var dateLOC = currentDate.toLocaleString('th-TH', options);

    let zone = this.filterList[0];
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.table.nativeElement);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    /* save to file */
    XLSX.writeFile(wb, 'อ้อยเข้าหีบสะสมรายกลุ่ม' + zone + '_' + dateLOC + '.xlsx');
  }

  // โหลดข้อมูล zone
  zonecode: any[] = [];
  LoadZone() {
    this.spinner.show();
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/zoneGroup";
    axios.get(url)
      .then(res => {
        this.zonecode = (res.data.recordset);
        this.spinner.hide();
      }).catch(err => { throw (err) })
    this.spinner.hide();
  }

  //โหดลยอดรายวันประจำกลุ่ม
  canebygroup: any[] = [];
  sumallbygroup: any[] = [];
  choosedate = '';
  listZones: any[] = [];
  LoadCanebyGroup() {
    let dateS = this.dateS;
    let date1 = this.date2en(dateS.date1)
    let date2 = this.date2en(dateS.date2);

    this.choosedate = this.formatDate2(date1) + " - " + this.formatDate2(date2);
    console.log('LoadCanebyGroup:', date1, date2)

    this.spinner.show();
    // let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/caneCollectGroupBydate6465_w?zone="+zone+"&redate1="+startday+"&redate2="+today;
    //let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/exec_f_v?f=[dbQBRD].[dbo].[caneCollectGroupBydate6566]&v='"+zone+"','"+startday+"','"+today+"'";
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/exec_f_v?f=[dbQBRD].[dbo].[caneCollectGroupBydate]&v='" + date1 + "','" + date2 + "'";

    axios.get(url)
      .then(res => {
        let data = res.data.recordset
        this.spinner.hide();
        if (data.length > 0) {
          this.canebygroup = data;
          this.filterbygroup = data;
          // console.log(this.canebygroup.map((el:any) => { return parseInt(el.area)}).reduce((a, b) => a + b, 0));
          this.sumdata(data);
          this.listZones = [...new Set(data.map((item) => item.supzone))];
        } else {
          this.canebygroup = [];
          this.filterbygroup = [];
        }
      }).catch(err => { throw (err) })
  }

  date2en(date: Date): string {
    if (!date) return '';
    const date1 = new Date(date);
    let options: any = {
      year: "numeric", month: "2-digit", day: "2-digit"//, hour: "2-digit", minute: "2-digit", timeZone: 'UTC'
    };
    return date1.toLocaleString('sv-SE', options);
  }

  filterbygroup = [];
  Selectbyzone(str: string) {
    let szone = str;//this.Pergroup.get('szone').value;
    console.log('szone:', szone.substring(0, 1), szone)
    if (szone.substring(0, 1) == 'P') {
      this.filterbygroup = this.canebygroup.filter((el: any) => el.Partcode == szone);
    }
    else if (szone == '0') { this.filterbygroup = this.canebygroup; }
    else { this.filterbygroup = this.canebygroup.filter((el: any) => el.supzone == szone); }
    this.sumdata(this.filterbygroup);
  }

  SelectbyQtype(str: number) {
    let sqtype = str;//this.Pergroup.get('sqtype').value;
    console.log('sqtype:', sqtype)
    if (sqtype >= 1 && sqtype <= 3) {
      this.filterbygroup = this.canebygroup.filter((el: any) => el.qtype == sqtype);
    }
    else {
      this.filterbygroup = this.canebygroup;
    }
    this.sumdata(this.filterbygroup);
  }

  filterList = ['', '']
  filterData() {
    let fil = this.filterList
    this.filterbygroup = this.canebygroup.filter((item) => {
      const matchSupzone =
        fil[0] == '' || item.supzone == fil[0];
      const matchQtype =
        fil[1] == '' || item.qtype == fil[1];
      return matchSupzone && matchQtype;
    });
    this.sumdata(this.filterbygroup);
  }

  // รวมค่าข้างล่าง
  sumdata(data: any) {
    let allassesscane = (data.map((el: any) => { return parseFloat(el.assess) })).reduce((a, b) => a + b, 0);
    let allcanein = (data.map((el: any) => { return parseFloat(el.canein) })).reduce((a, b) => a + b, 0);
    let pccanein = parseFloat(allcanein) / (parseFloat(allassesscane) / 100);
    let targetcaneinday = (data.map((el: any) => { return parseFloat(el.canetargetDate) })).reduce((a, b) => a + b, 0);
    let caneinday = (data.map((el: any) => { return parseFloat(el.caneindate) })).reduce((a, b) => a + b, 0);
    let pccaneinday = parseFloat(caneinday) / (parseFloat(targetcaneinday) / 100);
    this.sumallbygroup = [{
      'sumarea': (data.map((el: any) => { return parseFloat(el.area) })).reduce((a, b) => a + b, 0),
      'sumassess': (data.map((el: any) => { return parseFloat(el.assess) })).reduce((a, b) => a + b, 0),
      'sumcanein': (data.map((el: any) => { return parseFloat(el.canein) })).reduce((a, b) => a + b, 0),
      'sumTonNowleft': (data.map((el: any) => { return parseFloat(el.TonNowleft) })).reduce((a, b) => a + b, 0),
      'sumwgtnet0301': (data.map((el: any) => { return parseFloat(el.wgtnet0301) })).reduce((a, b) => a + b, 0),
      'sumcaneleft': (data.map((el: any) => { return parseFloat(el.caneleft) })).reduce((a, b) => a + b, 0),
      'sumcaneindate': (data.map((el: any) => { return parseFloat(el.caneindate) })).reduce((a, b) => a + b, 0),
      'sumcanewaitbrr': (data.map((el: any) => { return parseFloat(el.canewaitbrr) })).reduce((a, b) => a + b, 0),
      'sumcaneinFresh': (data.map((el: any) => { return parseFloat(el.caneinFresh) })).reduce((a, b) => a + b, 0),
      'sumareacuted': (data.map((el: any) => { return parseFloat(el.areacuted) })).reduce((a, b) => a + b, 0),
      'sumyieldCuted': (data.map((el: any) => { return parseFloat(el.yieldCuted) })).reduce((a, b) => a + b, 0) / data.length,
      'sumcanetargetDate': (data.map((el: any) => { return parseFloat(el.canetargetDate) })).reduce((a, b) => a + b, 0),
      'sumcaneinper': (data.map((el: any) => { return parseFloat(el.canetargetDate) })).reduce((a, b) => a + b, 0),
      'sumpccanein': pccanein,
      'sumpccaneintoday': pccaneinday,
      'sumcaneinchoose': (data.map((el: any) => { return parseFloat(el.canein_be) })).reduce((a, b) => a + b, 0),
      'sumccsinchoose': (data.map((el: any) => { return parseFloat(el.ccs_be) })).reduce((a, b) => a + b, 0) / data.length,
      'sumccs': (data.map((el: any) => { return parseFloat(el.ccs) })).reduce((a, b) => a + b, 0) / data.length,
      'sumassesscuted': (data.map((el: any) => { return parseFloat(el.assesscuted) })).reduce((a, b) => a + b, 0),
      'sumcanePerDay': (data.map((el: any) => { return parseFloat(el.canePerDay) })).reduce((a, b) => a + b, 0),
    }];
  }


  formatDate2(date: any) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = (d.getFullYear());

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;

    return [day, month, year].join('/');
  }

}
